import { render } from "./SurveyForm.vue?vue&type=template&id=24052b04&ts=true"
import script from "./SurveyForm.vue?vue&type=script&lang=ts"
export * from "./SurveyForm.vue?vue&type=script&lang=ts"

import "./SurveyForm.vue?vue&type=style&index=0&id=24052b04&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Surveys/Admin/SurveyForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24052b04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24052b04', __exports__)) {
    api.reload('24052b04', __exports__)
  }
  
  module.hot.accept("./SurveyForm.vue?vue&type=template&id=24052b04&ts=true", () => {
    api.rerender('24052b04', render)
  })

}


export default __exports__